import doc from '../images/about nurse.png'
import './About.css'

export default function About(){
    const aboutText = "For over 35 years, we have been dedicated to providing high-quality home health care services to our community. Our team of skilled professionals, including registered nurses, physical therapists, occupational therapists, speech therapists, and home health aides, is committed to delivering compassionate, patient-centered care in the comfort of your home."
    const missionText = "To provide compassionate, high-quality, and professional home health care services that enhance our patients’ quality of life while allowing them to remain safely in their own homes"
    const visionText = "To be the leading home health care provider in our community, known for our commitment to patient care, excellence, and innovation in health care."
    const valuesText = [["Compassion – Caring for patients with kindness and empathy", 1], ["Excellence – Providing top-tier care and medical expertise", 2], ["Integrity – Operating with honesty and transparency", 3], ["Respect – Valuing each patient's unique needs and dignity", 4], ["Patient-Centered Care – Creating individualized care plans for the best outcomes", 5]]
    const valuesMapped = valuesText.map((val) => <p key={val[1]}>{val[0]}</p>)
    return(
        <section id="about">
            <div id="AboutContainer1">
                <img id='about1' src={doc} alt="Doctor with stethoscope"/>
                <div>
                    <h2>Distinguished Home Health Care Services</h2>
                    <p>{aboutText}</p>
                </div>
            </div>
            <div id="AboutContainer2">
                <div className='ours'>
                    <h2>Our Mission</h2>
                    <p>{missionText}</p>
                </div>

                <div className='ours'>
                    <h2>Our Vision</h2>
                    <p>{visionText}</p>
                </div>
                
                <div className='ours'>
                    <h2>Our Values</h2>
                    {valuesMapped}
                </div>
            </div>
        </section>
    )
}